import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpService } from '../http.service';
import { SettingsService } from '../../settings/settings.service';

@Injectable({providedIn: 'root'})
export class UserApiProvider extends HttpService {
    /**
     * Serviço de integração ao backend da api de User
    */
   constructor(http: HttpClient, settingsService: SettingsService) {
        super('userApi', http, settingsService);
    }

}
